import React, {ReactElement, useEffect, useState} from 'react';

type Props = {
    title: string;
    children: ReactElement | ReactElement[];
};

const TabPane = ({children}: Props): JSX.Element => {
    const [isContentChanged, setIsContentChanged] = useState<boolean>(false)
    useEffect(() => {
        setIsContentChanged(false);
        //used to trigger css animation
        setTimeout(() => setIsContentChanged(true))


    }, [children]);
    return <>
        <div className="tab-body-wrapper">
            <div className={`animated`}>
                {isContentChanged && children}
            </div>
        </div>
    </>
};

export default TabPane;